import React from 'react';
import { ArrowLeft, Calendar } from 'lucide-react';
import "./InsightCard3.css";
import Navbar from '../Navbar';
import Footer from '../Footer';
import contributerImg from "../../assets/Team/Holt_ Spencer.jpg"

const InsightCard3 = () => {
  const handleBackClick = () => {
    window.location.href = '/insights';
  };

  return (
    <>
      <Navbar />
      
      <div className="insights-card3-detail-container">
        {/* Header Section */}
        <header className="insights-card3-header-section">
          <div className="insights-card3-header-overlay"></div>
          <div className="insights-card3-header-content">
            <button onClick={handleBackClick} className="insights-card3-back-button">
              <ArrowLeft size={20} />
              <span>Back to Insights</span>
            </button>
            <div className="insights-card3-header-text">
              <h1 className="insights-card3-main-title">
                Rethinking Finance Functions in High-Growth Companies
              </h1>
              <div className="insights-card3-article-meta">
                <Calendar size={16} />
                <span>Published on 24 July 2025</span>
              </div>
            </div>
          </div>
        </header>

        {/* Article Content */}
        <article className="insights-card3-article-content">
          <div className="insights-card3-content-wrapper">
            <div className="insights-card1-navigation-section">
              <a href="/insights" className="insights-card1-part-link">
              Read other related articles here →
              </a>
            </div>
            <div className="insights-card3-subtitle">
              Part 3 - Invest properly in talent and scalable systems
            </div>

            <h2 className="insights-card3-section-title">
                Don't Lock Yourself In Too Soon: Smart Finance Investments for Early-Stage and High-Growth Companies
              </h2>

            <div className="insights-card3-intro-paragraph">
              As I wrote in an earlier post, early-stage companies are primarily in the business of proving their business model. That means they need flexibility—especially in how they manage and measure their finances.
               <p>
                Too often, I see young companies rush to implement enterprise-grade finance systems before their business model is stable. For example, I've used NetSuite extensively throughout my career, and while it's a powerful tool, one that I would quickly recommend to many companies, it's also rigid by design. If not leveraged correctly, that rigidity becomes a liability when your business is still evolving. You end up fighting the system more than benefiting from it.
              </p>
            </div>

           

            <hr className="insights-card3-section-divider" />

          

            <section className="insights-card3-content-section">
              <h2 className="insights-card3-section-title">
               Here’s a better approach for early-stage companies:
              </h2>
              <p>
                Use flexible, modular systems that can adapt as your business does.That could mean QuickBooks or Xero as your general ledger, supplemented by Excel or customized tools for things like invoicing or billing when your business has more complexities that cannot be addressed by a spreadsheet. Choose tools that are "core-system agnostic"—they don't care what your ERP is and won't force you into a specific architecture too early.
              </p>

          

              <p>
                Yes, a modular setup may require a little more effort to connect the dots. But it also gives you freedom—freedom to evolve, test, and adapt your operations without being boxed in by a system designed for a company ten times your size.
              </p>

              <p>
                More importantly, rigid systems tend to come with rigid thinking.
              </p>

              <p>
                When you lock into someone else's structure too soon, you risk measuring what they thought was important—not what actually drives your business. In contrast, a more flexible system can surface the insights that matter to you—and point the way forward for the entire company.
              </p>
            </section>

            <hr className="insights-card3-section-divider" />

            <section className="insights-card3-content-section">
              <h2 className="insights-card3-section-title">
                 And speaking of locking in too soon…
              </h2>

              <p>
                I once had a job posting cross my desk that required "3+ years of Microsoft 365 experience"—just months after Microsoft 365 had launched. You can't hire someone with experience in a technology that didn't exist before. That's the kind of checkbox mentality that hurts high-growth companies.
              </p>

              <p>
                When hiring finance and leadership roles, don't look for people who've worked with a particular system. You don't need that as much as you need to look for people who can design new processes, adapt to changing needs, and help others adopt new ways of working. These are the people who will scale with you.
              </p>
              <p>
                I often hear the phrase "startup DNA." It's not always well-defined, but to me, it includes these qualities:
              </p>

              <div className="insights-card3-emphasis-section">
                <ul className="insights-card3-bullet-list">
                  <li>Curiosity</li>
                  <li>The ability to manage ambiguity and conflict</li>
                  <li>Empathy and rapport with coworkers</li>
                  <li>A deep understanding of what drives the business forward</li>
                </ul>
              </div>

              <p>
                These aren't just nice-to-haves. They're essential if you want your finance team—and your whole company—to help lead change rather than chase it.
              </p>
            </section>

            <hr className="insights-card3-section-divider" />

            <section className="insights-card3-content-section">
              <h2 className="insights-card3-section-title">
                Bottom Line ?
              </h2>

              <div className="insights-card3-closing-paragraph">
                <p>
                  Invest in talent and systems that are flexible, adaptive, and built for evolution—not perfection. Because in the early stages, your greatest asset isn't stability. It's the ability to grow into what your company needs to become.
                </p>
              </div>

              <div className="insights-card3-contributor-block">
                <img
                  className="insights-card3-contributor-img"
                  src={contributerImg}
                  alt="Spencer Holt"
                />
                <div className="insights-card3-contributor-details">
                  <h4 className="insights-card3-contributor-title">About the Contributor</h4>
                  <p className="insights-card3-contributor-bio">
                    <strong>Spencer Holt</strong> is a lifelong accounting and finance professional of VC and PE portfolio companies. He leads AlphaXN's fractional CFO practice.
                  </p>
                </div>
              </div>
            </section>

          </div>
        </article>
      </div>
      <Footer />
    </>
  );
};

export default InsightCard3;